import lang from 'lang'
import dunningConfig from 'dunning/config'
import settingsConfig from 'settings/config'
import request from '@/modules/base/util/request'

import { toast } from '@/modules/base/components/toast/toastConfig'

// actions
const SHOW_LOADER = 'settings/dunning/SHOW_LOADER'
const HIDE_LOADER = 'settings/dunning/HIDE_LOADER'
const FINISHED_FETCHING_DUNNING_SETTING = 'settings/dunning/FINISHED_FETCHING_DUNNING_SETTING'

// reducer
const initialState = {
  isLoading: false,
  autoDunningEnabled: false,
  dunningLevels: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, isLoading: true }

    case HIDE_LOADER:
      return { ...state, isLoading: false }

    case FINISHED_FETCHING_DUNNING_SETTING:
      const { data } = action
      return { ...state, ...data }

    default:
      return state
  }
};

// action creators
const showLoader = () => {
  return {
    type: SHOW_LOADER,
  }
}

const hideLoader = () => {
  return {
    type: HIDE_LOADER,
  }
}

const setDunningSetting = (data) => {
  return {
    type: FINISHED_FETCHING_DUNNING_SETTING,
    data,
  }
}

export const updateDunningLevel = (id, data) => {
  return (dispatch, getState) => {
    request(`${settingsConfig.dunningLevel}/${id}`, { method: 'PUT', auth: true, data })
      .then(() => {
        const { settings: { dunning: { dunningLevels } } } = getState()
        const newDunningLevels = dunningLevels.map(dunningLevel => {
          const { id: dunningLvlId } = dunningLevel
          return dunningLvlId === id ? { ...dunningLevel, ...data } : dunningLevel
        })

        dispatch(setDunningSetting({ dunningLevels: newDunningLevels }))
        toast.showToast({ message: lang.dunningSettingsSaveSuccessMessage })
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.dunningSettingsSaveErrorMessage })
      })
  }
}

export const updateAutoDunning = (autoDunningEnabled) => {
  return (dispatch) => {
    request(dunningConfig.settingsUrl, {
      auth: true,
      method: 'PUT',
      data: {
        autoDunningEnabled,
      },
    })
      .then((result) => {
        const { body: { data: { autoDunningEnabled } } } = result
        toast.showToast({ message: lang.dunningSettingsSaveSuccessMessage })
        dispatch(setDunningSetting({ autoDunningEnabled }))
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.dunningSettingsSaveErrorMessage })
      })
  }
}

export const fetchDunningSetting = () => {
  return (dispatch) => {
    dispatch(showLoader())
    Promise.all([
      request(settingsConfig.dunningLevel, { auth: true, isConcurrent: true }),
      request(dunningConfig.settingsUrl, { auth: true, isConcurrent: true }),
    ])
      .then(([dunningLevelResponse, dunningSettingResponse]) => {
        const { body: { data: dunningLevels } } = dunningLevelResponse
        const { body: { data: { autoDunningEnabled } } } = dunningSettingResponse
        dispatch(setDunningSetting({ dunningLevels, autoDunningEnabled }))
        dispatch(hideLoader())
      })
      .catch(() => {
        dispatch(hideLoader())
      })
  }
}
